import { Component, Output, EventEmitter, Input } from "@angular/core";
import { MONTH, CALENDARVIEW } from 'src/app/core/models/calendar.model';

@Component({
  selector: 'app-menu-calendar',
  templateUrl: './menu-calendar.component.html',
  styleUrls: ['./menu-calendar.component.scss']
})
export class MenuCalendarComponent {

  @Output() public openCalendar = new EventEmitter<boolean>();
  @Output() public selectViewMode = new EventEmitter<any>();
  @Output() public clickCalendar = new EventEmitter<any>();
  @Output() public clickGear = new EventEmitter<boolean>();
  @Output() public clickBack = new EventEmitter<number>();
  @Output() public clickNext = new EventEmitter<number>();
  @Output() public clickNow = new EventEmitter<boolean>();
  @Output() public openFilter = new EventEmitter<boolean>();
  @Output() public clearFilter = new EventEmitter<boolean>();
  @Output() public goTodayDate: EventEmitter<null> = new EventEmitter<null>();
  
  @Input() public incrementValue: number;
  @Input() public decrementValue: number;
  @Input() public showColumnCalendar = false;

  @Input() public year: string;
  @Input() public isSearch = false;
  @Input() public isAlert = false;
  @Input() public showFilter = false;

  public month: string;
  public isOpenCalendar = false;
  public isGear = false;
  public open = false;
  public optionsList = [CALENDARVIEW.Day, CALENDARVIEW.Week, CALENDARVIEW.Month];
  public calendarViewMode = CALENDARVIEW.Month;

  public options = {
    isIcon: true,
    iconRight: 'arrow_down',
    iconLeft: 'calender',
    listOptions: [CALENDARVIEW.Month, CALENDARVIEW.Week, CALENDARVIEW.Day]
  };

  @Input() set monthInput(indexMonth: number) {
    this.month = MONTH[indexMonth];
  }

  constructor() {  }

  public increment() {
    this.incrementValue += 1;
    this.clickNext.emit(this.incrementValue);
  }

  public decrement() {
    this.decrementValue -= 1;
    this.clickBack.emit(this.decrementValue);
  }

  public closeModal() {
    this.open = !this.open;
    this.openCalendar.emit(this.open);
  }

  goToday(): void {
    this.closeModal();
    this.goTodayDate.emit();
  }

  public selectItem(item: CALENDARVIEW): void {
    this.selectViewMode.emit(item);
    this.calendarViewMode = item;
  }

  public openMenu(): void {
    this.showColumnCalendar = !this.showColumnCalendar;
    this.openCalendar.emit(this.showColumnCalendar);
  }

  public openFilterClick(): void {
    this.showFilter = true;
    this.openFilter.emit(this.showFilter);
  }

}
